import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import { Button, Modal } from "react-bootstrap";
import { getWithAuth, putWithAuth } from "../../api/api";
import { API_URLS } from "../../api/apiConfig";
import ModalDeleteCleaning from "./modalDeleteCleaning";
import { ClockHistory } from "react-bootstrap-icons";
import ModalCleaningHistory from "./modalCleaningHistory";

const ModalCleaningUpdate = ({ onClose, cleaning_id }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingUpdate, setIsLoadingUpdate] = useState(false);
  const [alertMessage, setShowAlertMessage] = useState("");
  const [showAlert, setIshowAlert] = useState(false);
  const [updateCleaning, setCleaning] = useState({ is_forced: true });
  const [showHistoryModal, setShowHistoryModal] = useState(false);

  const openHistoryModal = () => setShowHistoryModal(true);
  const closeHistoryModal = () => setShowHistoryModal(false);

  const handleCleaningForce = (e) => {
    const value = e.target.value === "true";
    setCleaning((prev) => ({ ...prev, is_forced: value }));
  };

  const handleInputChange = (e) => {
    const { name, value, type } = e.target;
    setCleaning((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? !prev[name] : value,
    }));
  };

  const getCleaning = async () => {
    try {
      setIsLoading(true);
      const response = await getWithAuth(API_URLS.GET_CLEANING(cleaning_id));
      if (response.message === "success") {
        setCleaning(response.data);
      } else {
        setIshowAlert(true);
        setShowAlertMessage(response.detail || "Error al cargar la limpieza");
      }
    } catch (error) {
      console.error("Error al cargar limpieza:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const editCleaning = async () => {
    try {
      setIsLoadingUpdate(true);
      const response = await putWithAuth(
        API_URLS.EDIT_CLEANING(cleaning_id),
        updateCleaning
      );
      if (response.message === "success") {
        window.location.reload();
      } else {
        setIshowAlert(true);
        setShowAlertMessage(response.detail || "Ha ocurrido un error");
      }
    } catch (error) {
      console.error("Error al editar limpieza:", error);
    } finally {
      setIsLoadingUpdate(false);
    }
  };
  const isDeleted = Boolean(updateCleaning?.is_delete);

  const handleSave = async (e) => {
    e.preventDefault();
    await editCleaning();
  };

  useEffect(() => {
    getCleaning();
  }, []);

  const handleClickDelete = () => {
    if (Boolean(updateCleaning?.is_delete)) return; // ya eliminada → no hacer nada
    ModalDeleteCleaning.handleDelete(cleaning_id);
  };

  return (
    <>
      <Modal show={true} onHide={onClose} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title className="d-flex align-items-center w-100">
            <div className="d-flex align-items-center">
              Edición de limpieza (Reserva {updateCleaning.booking_external_id})
              {isDeleted && (
                <span className="badge bg-danger ms-2">Eliminada</span>
              )}
            </div>

            <Button
              size="sm"
              className="ms-auto d-flex align-items-center"
              onClick={openHistoryModal}
              title="Ver historial"
            >
              <ClockHistory className="me-1" />
              Historial
            </Button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="form">
            {isLoading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "10vh" }}
              >
                <div
                  className="spinner-grow text-color-amarillo-livensa"
                  style={{ width: "5rem", height: "5rem" }}
                  role="status"
                />
              </div>
            ) : (
              <>
                <div className="modal-body py-5 px-lg-17">
                  <div className="scroll-y me-n7 pe-7">
                    <div className="notice d-flex bg-light-warning rounded border-warning border border-dashed mb-10 p-6">
                      <i className="ki-outline ki-information fs-2tx text-warning me-4"></i>
                      <div className="d-flex flex-stack flex-grow-1">
                        <div className="fw-semibold">
                          <h4 className="text-gray-900 fw-bold">Atención!</h4>
                          <div className="fs-6 text-gray-700">
                            Cambiar una limpieza puede tener consecuencias en su
                            planificación.
                          </div>
                        </div>
                      </div>
                    </div>

                    {showAlert && (
                      <div className="alert alert-danger d-flex align-items-center p-5">
                        <i className="fa-solid fa-triangle-exclamation fs-1 text-danger me-4" />
                        <div className="d-flex flex-column">
                          <span className="mb-1 text-danger">
                            {alertMessage}
                          </span>
                        </div>
                      </div>
                    )}

                    <div className="d-flex flex-column mb-5">
                      <label className="form-label">Fecha de limpieza</label>
                      <Form.Control
                        type="date"
                        name="date_cleaning"
                        onChange={handleInputChange}
                        defaultValue={updateCleaning.date_cleaning}
                      />
                    </div>

                    <div className="d-flex flex-column mb-5">
                      <label className="form-label">Tipo de limpieza</label>
                      <select
                        className="form-select"
                        onChange={handleInputChange}
                        value={updateCleaning.cleaning_type}
                        name="cleaning_type"
                      >
                        <option value="L. Checkout">L. Checkout</option>
                        <option value="C. Textil">C. Textil</option>
                        <option value="L. Cliente">L. Cliente</option>
                      </select>
                    </div>

                    <div className="row g-9 mb-8">
                      <div className="col-md-12">
                        <div className="d-flex flex-stack">
                          <div className="me-5">
                            <label className="fs-6 fw-semibold form-label">
                              Fuerza la limpieza
                            </label>
                            <div className="fs-7 fw-semibold text-muted">
                              Las limpiezas de esta reserva no se verán
                              afectadas por el algoritmo
                            </div>
                          </div>
                          <select
                            onChange={handleCleaningForce}
                            name="is_forced"
                            value={updateCleaning.is_forced}
                            className="form-select w-auto"
                          >
                            <option value="true">Sí</option>
                            <option value="false">No</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="modal-footer flex-center">
                  <button
                    type="reset"
                    onClick={onClose}
                    className="btn btn-light me-3"
                  >
                    Cancelar
                  </button>

                  <button
                    type="button"
                    onClick={handleSave}
                    className="btn btn-primary"
                    data-kt-indicator={isLoadingUpdate ? "on" : "off"}
                    disabled={isDeleted}
                    title={
                      isDeleted
                        ? "La limpieza está eliminada y no se puede editar"
                        : undefined
                    }
                  >
                    <span className="indicator-label">Editar Limpieza</span>
                    <span className="indicator-progress">
                      Editando limpieza{" "}
                      <span className="spinner-border spinner-border-sm align-middle ms-2" />
                    </span>
                  </button>

                  <button
                    type="button"
                    onClick={handleClickDelete}
                    className="btn btn-light me-3"
                    disabled={isDeleted}
                    title={
                      isDeleted
                        ? "La limpieza ya está eliminada"
                        : "Eliminar limpieza"
                    }
                  >
                    Eliminar limpieza
                  </button>
                </div>
              </>
            )}
          </form>
        </Modal.Body>
      </Modal>

      {showHistoryModal && (
        <ModalCleaningHistory
          cleaning_id={cleaning_id}
          onClose={closeHistoryModal}
        />
      )}
    </>
  );
};

export default ModalCleaningUpdate;
